<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import {login} from '@/api/system';
import { setToken, removeToken } from '@/libs/auth'
export default {
    components: {},
    data() {
        return {
            metaType: this.$route.meta.type
        }
    },
    watch: {
        $route: {
            handler(newWord) {
                this.metaType = newWord.meta.type
            }
        }
    },
    methods: {
        // 登录
        // loginFun(){
        //     let param = {
        //         resource: true,
        //         username: '1585466356050436097',//supermen
        //     };
        //     login(param)
        //     .then((res) => {
        //         if(res.code=='401'){
        //             this.$message({
        //             message: res.message,
        //             type: 'error',
        //             duration: 3500});
        //         }
        //         else{
        //             removeToken();
        //             setToken(res.data.token);// 设置token
        //             window.localStorage.setItem('username', res.data.username);
        //         }
        //     })
        // }
    },
    mounted() {
        // 获取  通过路由地址 传过来的token
        var afterUrl = window.location.href.substring(1);
        var afterEqualParam = afterUrl.substring(afterUrl.indexOf('?')+1).split('=')
        if(afterEqualParam.length > 0 && afterEqualParam[0] == 'k'){
            let tempUrl = `${window.location.origin}${window.location.pathname}${window.location.hash}${window.location.search}`;
            var afterEqual = tempUrl.substring(tempUrl.indexOf('=')+1);
            removeToken();
            setToken(afterEqual);// 设置token
            // window.location.href = `${window.location.origin}${window.location.pathname}`;
            window.location.href = `${window.location.origin}${window.location.pathname}${window.location.hash}`;
            
            if(this.$route.path == '/home' || this.$route.path == '/'){
                this.$router.push({
                    path: 'home'
                });
            }
        }
    }
}
</script>

<style>
html {
    height: 97.5%;
    height: 100%;
}

body {
    height: 100%;
    width: 100%;
}

body #app {
    font-family: 'PingFang SC', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    width: 100%;
    font-weight: 500;
}
</style>